import { Box, Typography, useTheme } from '@mui/material'
import { c100Tokens, sectorColor, scrollbarSx } from './c100-tokens'

const MONO = "'IBM Plex Mono', monospace"

export default function FilterChips({
  label,
  options,
  value,
  onChange,
  withDots
}: {
  label: string
  options: string[]
  value: string
  onChange: (v: string) => void
  withDots?: boolean
}) {
  const theme = useTheme()
  const t = c100Tokens(theme)
  const all = ['All', ...options]

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1, minWidth: 0, width: '100%' }}>
      <Typography
        sx={{
          fontFamily: MONO,
          fontSize: 10,
          letterSpacing: '0.1em',
          color: t.muted,
          textTransform: 'uppercase',
          flexShrink: 0
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 0.5,
          alignItems: 'center',
          flexWrap: 'nowrap',
          overflowX: 'auto',
          overflowY: 'hidden',
          minWidth: 0,
          pb: 0.5,
          ...scrollbarSx(t)
        }}
      >
        {all.map(opt => {
          const active = value === opt
          const showDot = withDots && opt !== 'All'
          return (
            <Box
              key={opt}
              component="button"
              onClick={() => onChange(opt)}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                flexShrink: 0,
                whiteSpace: 'nowrap',
                fontFamily: MONO,
                fontSize: 10,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                fontWeight: active ? 600 : 400,
                color: active ? t.accent : t.muted,
                bgcolor: active ? t.faintAccentBg : 'transparent',
                border: `1px solid ${active ? t.accent : t.hairline}`,
                borderRadius: 999,
                cursor: 'pointer',
                px: 1.25,
                py: 0.4,
                transition: 'border-color .15s, color .15s',
                '&:hover': {
                  borderColor: active ? t.accent : t.text,
                  color: active ? t.accent : t.text
                }
              }}
            >
              {showDot && (
                <Box
                  component="span"
                  sx={{
                    width: 7,
                    height: 7,
                    borderRadius: '50%',
                    bgcolor: sectorColor(opt),
                    flexShrink: 0
                  }}
                />
              )}
              {opt}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
